<template>
  <v-dialog :value="dialog" scrollable :max-width="600" @input="onInputDialog">
    <page-loading :pageLoad="pageLoad"></page-loading>
    <v-card>
      <v-card-title>
        <span>Create a post</span>
        <v-spacer></v-spacer>
        <v-btn small icon @click="close">
          <v-icon small>far fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0 ma-0">
        <!-- <v-input>
          <div class="py-2" :style="{width: '100%'}">
            <textarea
              type="text"
              placeholder="What do you want to talk about?"
              :style="{width: '100%', padding: '8px 0px'}"
            ></textarea>
          </div>
        </v-input>-->
        <div class="pa-4">
          <v-textarea
            placeholder="What do you want to talk about?"
            auto-grow
            rows="3"
            hide-details
            :counter="1000"
            :maxlength="1000"
            autofocus
            v-model="text"
          ></v-textarea>
        </div>
        <template v-if="mode == 'other'">
          <v-file-input
            truncate-length="40"
            v-model="otherFile"
            label="Select File"
            class="pa-4 pt-0"
            prepend-icon=""
          ></v-file-input>
        </template>
        <template v-else-if="mode == 'audio'">
          <v-file-input
            truncate-length="40"
            v-model="audioFile"
            label="Select Audio File"
            class="pa-4 pt-0"
            prepend-icon=""
          ></v-file-input>
        </template>
        <template v-else-if="mode == 'gallery'">
          <div class="pa-4">
            <v-row no-gutters align-content="center" class="mb-2">
              <p class="col subtitle-1 my-auto">Gallery</p>
              <v-col cols="auto">
                <v-file-input
                  v-model="imageFiles"
                  v-on:change="onFileChange"
                  prepend-icon="mdi-plus"
                  accept="image/x-png, image/jpeg"
                  class="input-image-custom"
                  multiple
                  hide-input
                  color="primary"
                >
                </v-file-input
              ></v-col>
            </v-row>
            <v-row>
              <v-col
                v-for="n in list"
                :key="n.src"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card flat tile class="d-flex img">
                  <!--
                      :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`" 
                      :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                    -->
                  <v-img
                    :src="n.src"
                    :lazy-src="n.src"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <v-btn icon @click="deleteImage(n.src)" x-small>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-else-if="mode == 'youtube'">
          <div class="pa-4">
            <v-text-field
              placeholder="Youtube Url"
              v-model="youtubeUrl"
            ></v-text-field>
            <template v-if="youtubeUrl != null && youtubeUrl != ''">
              <vue-plyr>
                <div
                  data-plyr-provider="youtube"
                  :data-plyr-embed-id="youtubeUrl"
                ></div>
              </vue-plyr>
            </template>
          </div>
        </template>
        <post-link
          v-else-if="mode == 'link'"
          :setLinkData="setLinkData"
        ></post-link>
        <template v-else>
          <uploader
            ref="uploader"
            service="/"
            :accept="accept"
            :placeholder="uploadPlaceholder"
            :dense="true"
          ></uploader>
        </template>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              v-bind="attrs"
              v-on="on"
              icon
              @click="mode = 'gallery'"
              :color="mode == 'gallery' ? 'info' : ''"
            >
              <v-icon>far fa-images</v-icon>
            </v-btn>
          </template>
          Image
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              v-bind="attrs"
              v-on="on"
              icon
              @click="mode = 'youtube'"
              :color="mode == 'youtube' ? 'red' : ''"
            >
              <v-icon>fab fa-youtube</v-icon>
            </v-btn>
          </template>
          Youtube
        </v-tooltip>
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              v-bind="attrs"
              v-on="on"
              icon
              @click="openUploader('vdo')"
              :color="mode == 'vdo' ? 'green' : ''"
            >
              <v-icon>far fa-file-video</v-icon>
            </v-btn>
          </template>
          Video
        </v-tooltip> -->
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              v-bind="attrs"
              v-on="on"
              icon
              @click="openUploader('pdf')"
              :color="mode == 'pdf' ? 'red' : ''"
            >
              <v-icon>far fa-file-pdf</v-icon>
            </v-btn>
          </template>
          PDF
        </v-tooltip> -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              v-bind="attrs"
              v-on="on"
              icon
              @click="mode = 'link'"
              :color="mode == 'link' ? 'red' : ''"
            >
              <v-icon>far fa-link</v-icon>
            </v-btn>
          </template>
          Link
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              v-bind="attrs"
              v-on="on"
              icon
              @click="mode = 'audio'"
              :color="mode == 'audio' ? 'red' : ''"
            >
              <v-icon>far fa-file-audio</v-icon>
            </v-btn>
          </template>
          Audio
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              v-bind="attrs"
              v-on="on"
              icon
              @click="mode = 'other'"
              :color="mode == 'other' ? 'red' : ''"
            >
              <v-icon>far fa-file</v-icon>
            </v-btn>
          </template>
          Other
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          :color="$buttonColor"
          @click="createPost"
          class="white--text"
          >Post</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Uploader from "@/components/Uploader.vue";
import Vue from "vue";
import LinkPost from "./post/LinkPost.vue";
import PageLoading from "@/components/post/PageLoading.vue";

export default {
  components: {
    Uploader,
    "post-link": LinkPost,
    "page-loading": PageLoading,
  },
  data: () => ({
    dialog: false,
    mode: "gallery",
    pageLoad: false,
    youtubeUrl: "",
    uploadPlaceholder: "Choose file to upload",
    text: "",
    info: {},
    imageFiles: [],
    list: [],
    imageUploadId: [],
    imageForCreatePost: [],
    linkData: null,
    otherFile: null,
    audioFile: null,
  }),
  computed: {
    courseId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.info = Vue.prototype.$userInfo;
    this.getPosts();
  },
  methods: {
    setLinkData(data) {
      this.linkData = data;
    },
    deleteImage(url) {
      this.list = this.list.filter((l) => l.src !== url);
      this.imageForCreatePost = this.imageForCreatePost.filter(
        (l) => l.url !== url
      );
    },
    async uploadFile(file) {
      // this.showUploadPercent = true;
      let formData = new FormData();
      formData.append("fileupload", file);
      formData.append("title", file.name);
      await Vue.axios
        .post(`${this.$store.state.api}/post/uploadfile/image`, formData, {
          ...this.$store.getters.requestHeaders,
          onUploadProgress: function (progressEvent) {
            // this.progressPercent = parseInt(
            //   Math.round((progressEvent.loaded / progressEvent.total) * 100)
            // );
          }.bind(this),
        })
        .then(
          async function (response) {
            await this.imageUploadId.push(response.data.result.url);
            await this.imageForCreatePost.push(response.data.result);
            // await this.oldFileId.push(response.data.result);
            let imgUrl = response.data.result.url;
            await this.list.push({ src: imgUrl });
            // await this.oldFileUrl.push({ src: imgUrl });
          }.bind(this)
        )
        .catch(function (e) {});
    },
    async onFileChange(files) {
      this.pageLoad = true;
      this.successUpload = false;
      let totalFiles;
      totalFiles = files.length;
      let resultImg;
      if (this.list.length + totalFiles > 20) {
        resultImg = 20 - this.list.length;
        this.warnnig(
          `คุณสามารถอัพโหลดรูปภาพได้อีก ${resultImg} รูปเท่านั้น กรุณาเลือกรูปใหม่อีกครั้ง`,
          "warning"
        );
        this.successUpload = true;
        this.imageFiles = [];
        return;
      }
      if (totalFiles === 0) {
        this.successUpload = true;
        return;
      } else {
        for (var i = 0; i < totalFiles; i++) {
          await this.uploadFile(files[i]);
        }
        this.successUpload = true;
        this.imageFiles = [];
      }
      this.pageLoad = false;
    },
    onInputDialog(val) {
      this.dialog = val;
    },
    open(targetMode) {
      this.clear();
      this.$nextTick(() => {
        if (targetMode != null) {
          this.mode = targetMode;
        }
        this.dialog = true;
      });
    },
    close() {
      this.dialog = false;
    },
    clear() {
      this.mode = "gallery";
    },
    openUploader(mode) {
      this.mode = mode;
      if (mode == "vdo") {
        this.uploadPlaceholder = "Choose video file to upload";
        this.accept = "video/*";
      } else {
        this.uploadPlaceholder = "Choose PDF file to upload";
        this.accept = "application/pdf";
      }
      setTimeout(() => {
        this.$refs.uploader.clear();
      }, 100);
    },
    getPosts() {
      // const url = this.$store.getters.urlQueryParameter(`${this.$store.state.api}-get`, {
      //   idcourse: this.courseId,
      //   limit: 100,
      //   page: 1,
      // });
      // Vue.axios
      //   .get(url, this.$store.getters.requestHeaders)
      //   .then((res) => {})
      //   .catch((err) => {})
      //   .finally(() => {});
    },
    clearForm() {
      this.text = "";
      this.imageForCreatePost = [];
      this.youtubeUrl = "";
      this.list = [];
      this.mode = "gallery";
    },
    createPost() {
      // this.$store.dispatch("createPost", {
      //   text: this.text,
      //   courseId: this.courseId,
      // });
      let formData;
      let dataCreatePost = {
        text: this.text,
        idcourse: this.courseId,
        canComment: true,
      };
      if (
        this.mode === "gallery" &&
        this.imageForCreatePost &&
        this.imageForCreatePost.length > 0
      ) {
        dataCreatePost.images = this.imageForCreatePost;
      } else if (
        this.mode === "youtube" &&
        this.youtubeUrl &&
        this.youtubeUrl.length > 0
      ) {
        dataCreatePost.urlyoutube = this.youtubeUrl;
      } else if (this.mode === "link") {
        dataCreatePost.link = this.linkData;
      } else if (this.mode === "other" || this.mode === "audio") {
        formData = new FormData();
        formData.append("text", dataCreatePost.text);
        formData.append("idcourse", dataCreatePost.idcourse);
        formData.append("canComment", dataCreatePost.canComment);
        dataCreatePost = undefined;
        if (this.mode === "other") {
          formData.append("otherFile", this.otherFile);
        } else if (this.mode === "audio") {
          formData.append("audio", this.audioFile);
        }
      }
      if (dataCreatePost) {
        this.sendNormal(dataCreatePost);
      } else if (formData) {
        this.sendNormal(formData);
      }
    },
    sendNormal(data) {
      this.pageLoad = true;
      Vue.axios
        .post(
          `${this.$store.state.api}/post/manage/insert`,
          data,
          this.$store.getters.requestHeaders
        )
        .then((res) => {
          this.pageLoad = false;
          this.dialog = false;
          this.$store.commit("updatePostList", res.data.result);
          this.clearForm();
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-image-custom {
  padding: 0;
  margin: 0;

  .v-input__prepend-outer {
    margin: 0;
  }

  button {
    color: #f97a92 !important;
  }
}

.img {
  position: relative;

  button {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #fff;
  }
}
</style>
